import React from "react"
import { useDispatch, useSelector } from "react-redux";
import { StyledModalBody } from "../../../../../components/Modals";
import { ButtonBodyVariant } from "../../../../../components/ui/ButtonVariant";
import { useTranslation } from "react-i18next";
import { closeActiveModal, openModal } from "../../../../../helper/modals";
import styled from "styled-components";
import { Flex } from "../../../../../components/ui/Flex";
import { Form, FormControl, FormField, FormItem, FormMessage } from "../../../../../components/ui/Form";
import { useForm } from "react-hook-form";
import { DescriptionText, ModalButtonsContainer, PAYMENT_BANK_OPTIONS, PaymentModal, StepItem, LightBlueText, TitleText } from "../../../PaymentComponents";
import * as Yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";
import { updatePaymentData } from "../../../../../redux/actions/payments";
import { ToggleGroup, useToggleGroupContext } from "../../../../../components/ui/ToggleGroup";
import { IoCheckmarkCircle } from "react-icons/io5";
import { FaRegCircle } from "react-icons/fa";

const schema = Yup.object().shape({
  institutionNumber: Yup.array()
    .required('A bank selection is required')
    .length(1, 'A bank must be selected')
});

const SetupBankingDetailsStep1 = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const modal = useSelector((state) => state.headerModal.modal);
  const addPayment = useSelector((state) => state.addPayment);

  const form = useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
    defaultValues: {
      institutionNumber: addPayment.institutionNumber ? [addPayment.institutionNumber] : undefined
    }
  });

  const onSubmit = (values) => {
    dispatch(updatePaymentData({
      institutionNumber: values.institutionNumber[0]
    }))
    openModal('SetupBankingDetailsStep2')
  }

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <PaymentModal
          show={modal === 'SetupBankingDetailsStep1'}
          onClose={closeActiveModal}
          closeOnBackdrop={false}
          width={'460px'}>
          <StyledModalBody>
            <Flex direction="column" gap="1rem">
              <Flex direction="column">
                <Flex justify="space-between" alignItems="center" style={{ width: "100%" }}>
                  <LightBlueText> STEP 1/2</LightBlueText>
                  <Flex gap="0.5rem">
                    <StepItem filled />
                    <StepItem />
                  </Flex>
                </Flex>
                <TitleText>Banking Details</TitleText>
              </Flex>

              <Flex direction="column" alignItems="center" gap="1rem">
                <FormField
                  control={form.control}
                  name="institutionNumber"
                  render={({ field }) => (
                    <FormItem alt>
                      <FormControl>
                        <ToggleGroup
                          single
                          {...field}
                          onValueChange={(values) => {
                            field.onChange(values);
                          }}>
                          <Flex justify="space-between" gap="1rem" direction="column">
                            {PAYMENT_BANK_OPTIONS.map((bank) => <ToggleGroupItem value={bank.id} key={bank.institutionNumber} bank={bank} />)}
                          </Flex>
                        </ToggleGroup>
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />

              </Flex>
              <ModalButtonsContainer gapY="8px">
                <ButtonBodyVariant cssOverride="width: 8.875rem; height: 2rem;" type="button" variant="secondary" onClick={closeActiveModal}>{t('Cancel')}</ButtonBodyVariant>
                <ButtonBodyVariant cssOverride="width: 8.875rem; height: 2rem;" type="submit">{t('Next')}</ButtonBodyVariant>
              </ModalButtonsContainer>
            </Flex>
          </StyledModalBody>
        </PaymentModal>
      </form>
    </Form>
  )
}

const ToggleGroupItem = ({ value, bank, ...rest }) => {
  const toggleGroupContext = useToggleGroupContext();
  const checked = toggleGroupContext.values.includes(value);

  return (
    <Flex alignItems="center" justify="space-between"
      onClick={() => {
        if (checked) {
          toggleGroupContext.onItemDeactivate(value);
        } else {
          toggleGroupContext.onItemActivate(value);
        }
      }}
      {...rest}>
      <Flex alignItems="center" gap="1rem">
        <BankLogoContainer>
          {bank.logo}
        </BankLogoContainer>
        <DescriptionText>{bank.name}</DescriptionText>
      </Flex>
      {checked ? <IoCheckmarkCircle size={29} style={{ cursor: "pointer" }} /> : <FaRegCircle size={26} style={{ cursor: "pointer" }} />}
    </Flex>
  );
};

const BankLogoContainer = styled.div`
  position: relative;
`

export default SetupBankingDetailsStep1
